import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import TextInput from 'components/Inputs/TextInput'
import BundleList from 'components/Lists/BundleList'
import AddBundleModal from 'pages/Modals/AddBundleModal'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'

import {
  Container,
  Row,
  InfoText,
  LinkText
} from '../styles'

export default function EditBundles () {
  const [loading, setLoading] = useState (true)
  const [bundles, setBundles] = useState ([])
  const [name, setName] = useState ('')
  const [showAddBundleModal, setShowAddBundleModal] = useState (false)
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()
  const location = useLocation ()
  const isTutorial = !!location.state?.isTutorial

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [name])

  const getData = async () => {
    let filters = ''
    if (name) filters += `&name=${encodeURIComponent (name)}`
    
    try {
      setLoading (true)

      const { data: bundles } = await cutileiApi.get (
        `/businesses/${businessId}/bundles?status=active${filters}`, requestConfig
      )
      setBundles (bundles)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const compareBundles = (a, b) => (
    DateTime.fromISO (a.created_at).toMillis () - DateTime.fromISO (b.created_at).toMillis ()
  )

  const toggleAddBundleModal = () => setShowAddBundleModal (!showAddBundleModal)

  return (
    <Container>
      {isTutorial && (
        <InfoText style={{marginTop: -5, marginBottom: 15}}>
          <LinkText to='/business'>
            {'Clique aqui '}
          </LinkText>
          para voltar para o <b>guia de configuração do salão</b>
        </InfoText>
      )}
      <Row style={{gap: 10, width: 600}}>
        <TextInput
          value={name}
          placeholder='Pesquisar por nome'
          isClearable={true}
          onChange={e => setName (e.target.value)}
          onClear={() => setName ('')}
          inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
          containerStyle={{width: 360}}
        />
        {AuthService.hasPermission ('business_config.bundles', 'edit') && (
          <>
            <SecondaryButton
              label='Criar pacote'
              onClick={toggleAddBundleModal}
              width={140}
            />
            <AddBundleModal
              visible={showAddBundleModal}
              onConfirm={addedBundle => setBundles (
                [...bundles, addedBundle].sort (compareBundles)
              )}
              onClose={toggleAddBundleModal}
            />
          </>
        )}
      </Row>
      {loading ? <Loading/> : (
        <BundleList
          bundles={bundles}
          onEdit={bundle => setBundles (bundles.map (b => b.id === bundle.id ? {...bundle} : b))}
          onDelete={deletedService => setBundles (bundles.filter (s => s.id !== deletedService.id))}
        />
      )}
    </Container>
  )
}
